// function ValidationAlert({ message }) {
//   return (
//     <div
//       className="position-fixed top-0 start-50 translate-middle-x mt-3"
//       style={{ zIndex: 1000, width: "auto", maxWidth: "90%", fontSize: "14px" }}
//     >
//       <div
//         className="alert alert-warning alert-dismissible fade show mb-0"
//         role="alert"
//       >
//         <strong>
//           <pre>{message}</pre>
//         </strong>
//       </div>
//     </div>
//   );
// }

// export default ValidationAlert;
function ValidationAlert({ message }) {
  return (
    <div
      className="position-fixed top-0 start-50 translate-middle-x mt-3"
      style={{
        zIndex: 1000,
        maxWidth: "95%",
        width: "auto",
        display: "flex",
        justifyContent: "center",
        padding: "0 10px",
        pointerEvents: "none",
      }}
    >
      <div
        role="alert"
        style={{
          background: "linear-gradient(135deg, #fde2e4, #fff1f2)",
          color: "#7f1d1d",
          padding: "24px 30px",
          borderRadius: "16px",
          fontSize: "17px",
          fontWeight: "500",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
          border: "1px solid #f9a8d4",
          minWidth: "350px",
          maxWidth: "600px",
          pointerEvents: "auto",
          animation: "fadeIn 0.3s ease-in-out",
        }}
      >
        <pre
          style={{
            margin: 0,
            whiteSpace: "pre-wrap",
            fontFamily: "inherit",
            lineHeight: "1.6",
          }}
        >
          {message}
        </pre>
      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}

export default ValidationAlert;
